import { Link } from "react-router-dom";
import { FOOTER_LINKS } from "../data/siteContent";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-ink pt-16 pb-8">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="font-sans text-xl font-semibold text-white">
              Inception<span className="italic text-accent-light">Creative</span>
            </p>
            <p className="mt-4 font-sans text-sm leading-relaxed text-corporate-slate">
              Premium advertising, branding, and design studio for brands that demand excellence.
            </p>
          </div>
          <div>
            <p className="eyebrow-corporate text-white/40">Quick links</p>
            <ul className="mt-4 space-y-2">
              {FOOTER_LINKS.company.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-white/60 transition hover:text-accent-light">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="eyebrow-corporate text-white/40">Services</p>
            <ul className="mt-4 space-y-2">
              {FOOTER_LINKS.services.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-white/60 transition hover:text-accent-light">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-white/40">Connect</p>
            <ul className="mt-4 space-y-2">
              {FOOTER_LINKS.social.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-white/60 transition hover:text-accent-light">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
            <Link
              to="/login"
              className="mt-6 inline-block text-sm font-semibold text-accent-light hover:text-white"
            >
              Client Sign In →
            </Link>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-center text-xs text-white/40 sm:flex-row sm:text-left">
          <p>© {year} Inception Creative. All rights reserved.</p>
          <p>Advertising · Branding · Social Media · Print Design</p>
        </div>
      </div>
    </footer>
  );
}

